import React, {useCallback, useEffect, useState, useMemo} from 'react';
import {
	Slider,
	Select,
	Input,
	Button,
	SelectOption, MultiSelect, MultiSelectOption, Loader, Toast,
} from '@kaleyra/emmy';
import Styles from './Domain.module.scss';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import {isEmpty} from "lodash";
import * as urls from "../../../../urls";
import AddIcon from "../../../../assets/addV.png";
import {useHistory} from "react-router-dom";
import ApprovedGreen from '../../../../assets/approvedGreen.svg'
import ApprovedRed from '../../../../assets/approvedRed.svg'
import {DOMAIN_VALIDATION_REGEX} from "../../../../constants";

export type MapStateToPropsType = {
	params: any;
	inProgress:boolean|undefined,
	credentialGroupList:Record<string, any>,
	sipDomainLocation: Record<string, string>,
	sipDomainLocationInProgress: boolean|undefined
};

export type MapDispatchToPropsType = {
	closeModal: () => void;
	loadCredentialGroups : () => void,
	getSipDomainLocations : ( cb:(res:any,success:boolean) => void ) => void,
	checkDomainAvailability : (domain:string,cb?:(res:any,success:boolean)=>void) => void,
	onCreateDomain : (reqData: any, keyForIdentifier:string,  cb?: (res: any, success: boolean) => void) => void,
	onEditDomain : (reqData: any, dynamicUrlData:string, keyForIdentifier:string,  cb?: (res: any, success: boolean) => void) => void,
};

const AddEditDomainModal: React.FC<MapStateToPropsType & MapDispatchToPropsType> = (
	{
		closeModal,
		loadCredentialGroups,
		credentialGroupList,
		params,
		onCreateDomain,
		onEditDomain,
		inProgress,
		getSipDomainLocations,
		sipDomainLocation,
		sipDomainLocationInProgress,
		checkDomainAvailability,
	}) => {
	const [isDomainAvailable, setIsDomainAvailable] = useState<boolean>(false);
	const [domainName, setDomainName] = useState<string | undefined>(undefined);
	// const [domainName, setDomainName] = useState<undefined|string>(undefined);
	const [showDomainAvailability, setShowDomainAvailability] = useState<boolean>(false);
	// const [acl, setAcl] = useState<string[]>([]);
	const [credentialGroups, setCredentialGroups] = useState<string[]>([]);
	const [domainLocation, setDomainLocation] = useState<string | undefined>(undefined);
	const [domainSuffix, setDomainSuffix] = useState<string | undefined>(undefined);
	const { t } = useTranslation();
	const history = useHistory();
	const { data, edit = false } = params;
	useEffect(()=>{
		loadCredentialGroups();
		getSipDomainLocations( (res:any,success:boolean)=>{
			if(edit && !isEmpty(data)){
				const {domain_name, credential_group_id, region_name} = data; // todo replace "credential_groups" with actual key
				setDomainName(domain_name.replace(/(.*)(\..*\..*\..*)/,'$1'));
				setCredentialGroups(Object.values(credential_group_id||{}));
				setDomainLocation(region_name);
				setDomainSuffix(`.${getDomainFromLocation(res.data,region_name)}`);
			}
		});
	},[]);
	const getDomainFromLocation = useCallback((sipDomainLocation:Record<string, string>,location) =>{
		const matchedLocation = Object.entries(sipDomainLocation).find( (el:any) => {
			return el[1] === location;
		});
		return matchedLocation && matchedLocation[0];
	},[])
	const handleSave = useCallback(() => {
		if(!domainSuffix || isEmpty(credentialGroups)) return;
		if(!edit) {
			onCreateDomain(
				{
					domain_name: `${domainName}${domainSuffix}`,
					credential_group_id: credentialGroups
				},
				"domain_id",
				(res:any,success:boolean)=>{
					if(success) Toast(t('KLR00492'),'success');
					else if(res?.data?.message) Toast(res?.data?.message,'error');
				});
		} else{
			onEditDomain(
				{
					credential_group_id: credentialGroups,
					credential_group_count: (credentialGroups || []).length,
					domain_id: (data||{}).domain_id
				},
				(data||{}).domain_id,
				"domain_id",
				(res:any,success:boolean)=>{
					if(success) Toast(t('KLR00493'),'success');
					else if(res?.data?.message) Toast(res?.data?.message,'error');
				});
		}
		closeModal();
	},[isDomainAvailable,domainSuffix,credentialGroups]); // add acl when required

	const enableSaveButton = useMemo(() => {
		if( (!edit && !isDomainAvailable) || isEmpty(credentialGroups)) return false;
		return true;
	},[isDomainAvailable,credentialGroups]);

	const renderFooter = () => {
		return (
			<div className={Styles.footer}>
				<span className={Styles.cancelBtn}>
					<Button type="tertiary" onClick={closeModal}>
						{t('mainCancel')}
					</Button>
				</span>
				<Button
					disabled={!enableSaveButton}
					type="primary"
					onClick={handleSave}
				>
					{t('mainSave')}
				</Button>
			</div>
		);
	};

	useEffect(()=>{
		// loadDropdownData({});
	},[]);

	const domainAvailableMsg = useMemo(() => {
		return isDomainAvailable ?
			<span>
				<img src={ApprovedGreen} alt={"approved"}/>
				<span className={cn(Styles.domainMsg)}>{t("KLR00473")}</span>
			</span> :
			<span>
				<img src={ApprovedRed} alt={"unapproved"}/>
				<span className={cn(Styles.domainMsg)}>{t("KLR00474")}</span>
			</span>;

	},[isDomainAvailable]);
	const handleAddNewUserGroup = useCallback(() => {
		closeModal();
		history.push(urls.v1SoundManager({ tab: 'sip-user-group' }))
	},[]);

	return (
		<Slider
			title={edit? t('KLR00461') : t('KLR00460')}
			containerId="root-modal"
			onClose={closeModal}
			visibility={true}
			footer={renderFooter()}
		>
			{ (inProgress || inProgress === undefined || sipDomainLocationInProgress || sipDomainLocationInProgress === undefined) && <Loader/>}
			{ inProgress === false && sipDomainLocationInProgress === false && <div className={cn(Styles.container, 'addEditDomainModal')}>
				<div className={Styles.ipBoxM1}>
					{edit ? <Input
						placeholder={t('KLR00468')}
						label={t('KLR00468')}
						showBottomLabelSpace={ false }
						bottomLabelType={ undefined }
						value={domainLocation}
						disabled={true}
					/> : <Select
						label={t('KLR00468')}
						placeholder={t('KLR00468')}
						value={domainLocation}
						onChange={(e) => {
							const val = (e||"").toString();
							setDomainLocation(val);
							setDomainSuffix(`.${getDomainFromLocation(sipDomainLocation,val)}`);
						}}
						showBottomLabelSpace={ false }
						bottomLabelType={ undefined }
						// disabled={edit}
					>
						{!isEmpty(sipDomainLocation) && Object.values(sipDomainLocation).map( (val:string) => {
							return (
								<SelectOption
									key={val}
									value={val}
								>
									{val}
								</SelectOption>
							);
						})}
					</Select>}
				</div>
				{domainLocation &&
					<>
						<div className={Styles.mrgTop}>
							<Input
								placeholder={t('KLR00471')}
								inputClassName={cn("addOnAfter")}
								className={cn(Styles.domainInput, (showDomainAvailability && !isDomainAvailable) ? "addOnError" : "")}
								label={t('KLR00471')}
								showBottomLabelSpace={ showDomainAvailability }
								bottomLabelType={ showDomainAvailability ? (!isDomainAvailable ? "error" : "success") : undefined}
								bottomLabel={ showDomainAvailability && domainAvailableMsg }
								value={domainName}
								onFocus={() => {
									setIsDomainAvailable(false);
									setShowDomainAvailability(false)
								}}
								onBlur={() => {
									if(!domainName) return;
									if( ['_', '-'].indexOf(domainName[0]) >= 0 || ['_', '-'].indexOf(domainName[domainName.length - 1]) >= 0) {
										setShowDomainAvailability(true);
										return setIsDomainAvailable(false);
									}
									checkDomainAvailability(`${domainName}${domainSuffix}/valid`,(res:any,success:boolean)=>{
										if(success){
											setIsDomainAvailable(res.data);
										}else setIsDomainAvailable(false);
										setShowDomainAvailability(true);
									});
								}}
								onChange={(e: any) => {
									const val = e.target.value;
									if(val && val.length > 32) return;
									if(DOMAIN_VALIDATION_REGEX.test(e.target.value)) return;
									setDomainName(val);
								}}
								addonAfter={domainSuffix}
								disabled={edit}
							/>
						</div>
						<div className={Styles.mrgTop}>
							<MultiSelect
								placeholder={t('KLR00470')}
								selectedValues={credentialGroups}
								value={credentialGroups}
								onChange={(value: any) =>
									setCredentialGroups(value)
								}
								mode="multiple"
								defaultValue={credentialGroups}
								maxTagCount={6}
								dropdownRender={(menu) => {
									return (
										<div>
											<div className={Styles.addContainer}
												 onClick={handleAddNewUserGroup}>
												<img className={Styles.mrgRSm} src={AddIcon} alt='' />
												<span>{t("KLR00472")}</span>
											</div>
											{menu}
										</div>
									)
								}}
							>
								{credentialGroupList && credentialGroupList.map((el:any) => (
									<MultiSelectOption
										key={el.credential_group_id}
										value={el.credential_group_id}
									>
										{el.credential_group_name}
									</MultiSelectOption>
								))}
							</MultiSelect>
						</div>
					</>
				}
			</div>}
		</Slider>
	);
};

export default AddEditDomainModal;
